






























import Vue from 'vue';
import FilterTable from '../components/filter/FilterTable.vue';
import FilterSettings from '../components/filter/FilterSettings.vue';
import customerClient from '../apis';
import customerVuex from '../vuex/common';

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    FilterTable,
    FilterSettings,
  },
  data() {
    return {
      neverFilteredHeight: 0,
      filtered: false,
      loaded: false,
    };
  },
  computed: {
    neverFilteredStyles(): any {
      return {
        height: `${this.neverFilteredHeight}px`,
      };
    },
  },
  methods: {
    setNeverFilteredHeight() {
      this.neverFilteredHeight = window.document.body.offsetHeight - 120;
    },
  },
  beforeMount() {
    const href = window.location.href;
    if (href.indexOf('back=true') === -1) {
      this.$store.commit('INIT_CUSTOMER_FILTER');
      this.$store.commit('INIT_CUSTOMER_QUERY');
    }
  },
  mounted() {
    const appContent: any = window.document.getElementById('app-content');
    appContent.onscroll = (event: any) => {
      if (!this.customerState.showCustomerExport &&
          !this.customerState.showCustomerAnalyze) {
        event.preventDefault();
      }
    };
    appContent.onmousewheel = (event: any) => {
      if (!this.customerState.showCustomerExport &&
          !this.customerState.showCustomerAnalyze &&
          !this.customerState.showCustomerDetail) {
        event.preventDefault();
      }
    };
    this.setNeverFilteredHeight();

    customerClient.getProps().success((r) => {
      this.$store.commit('SET_CUSTOMER_PROPS', r.props);
    });
  },
  beforeDestroy() {
    const appContent: any = window.document.getElementById('app-content');
    appContent.onscroll = (event: any) => {
      return true;
    };
    appContent.onmousewheel = (event: any) => {
      return true;
    };
  },
});
